import React, { useState, useEffect, useRef } from 'react';

const LazyLoad = ({ children }) => {
    const [isVisible, setIsVisible] = useState(false);
    const divRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.05 } // Trigger when 10% of the div is in view
        );

        if (divRef.current) {
            observer.observe(divRef.current);
        }

        return () => {
            if (divRef.current) {
                observer.disconnect();
            }
        };
        
    }, []);

    return (
        <div ref={divRef}>
            {isVisible ? children : <div>Loading...</div>} {/* Placeholder content */}
        </div>
    );
};

export default LazyLoad;
